import React, { useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useTheme
} from "@mui/material";
import { CloudUpload, Delete } from "@mui/icons-material";
import FileUploadModel from "../../fileUploadModal";
import { deleteUserProfilePic, saveUserProfilePic } from "../../../redux/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNotification } from "../../shared/NotificationProvider";

const ProfileCard = ({ profileObj, userInfo }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const notify = useNotification();

  const [open, setOpen] = useState(false);

  const fileUploadProps = { maxNumber: 1 };
  const userAddressDetails = useSelector((state) => state.user.userAddressDetails);

  const handleUploadFile = async (e, files, setOpen) => {
    setOpen(false);
    try {
      const res = await dispatch(saveUserProfilePic({ profilePicture: files[0] }));
      notify[res.payload.status === "success" ? "success" : "error"](res.payload.message);
    } catch {
      notify.error("System level error occurred");
    }
  };

  const cardSx = {
    p: 3,
    textAlign: "center",
    borderRadius: "4px",
    backgroundColor: "#001d3d",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    border: "1px solid rgba(255,255,255,0.12)",
    transition: "all 0.3s ease",
    "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.4)" },
  };

  return (
    <Card sx={cardSx}>
      <Avatar
        src={profileObj?.url || "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"}
        sx={{
          width: 140,
          height: 140,
          mx: "auto",
          mb: 2,
          border: "4px solid #fff",
          boxShadow: theme.shadows[2]
        }}
      />
      <Typography variant="h5" sx={{ mb: 1, color: "#fff", fontSize: "1.25rem", fontWeight: 600 }}>
        {userInfo.name}
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: "rgba(255,255,255,0.7)", fontSize: "0.85rem" }}>
        {`${userAddressDetails?.landmark}, ${userAddressDetails?.city}` || "Location not specified"}
      </Typography>

      <Button
        variant="contained"
        fullWidth
        startIcon={<CloudUpload />}
        onClick={() => setOpen(true)}
        sx={{
          mb: 2,
          fontSize: "0.85rem",
          backgroundColor: "#fff",
          color: "#001d3d",
          "&:hover": { backgroundColor: "#e0e0e0" },
        }}
      >
        Upload Avatar
      </Button>

      <Button
        variant="outlined"
        fullWidth
        startIcon={<Delete />}
        onClick={async () => {
          const confirmed = await notify.confirm({
            title: "Delete profile picture",
            message: "Are you sure you want to delete your profile picture ?",
          });
          if (confirmed) {
            try {
              const res = await dispatch(deleteUserProfilePic());
              notify[res.payload.status === "success" ? "success" : "error"](res.payload.message);
            } catch {
              notify.error("Some system level error occurred");
            }
          } else {
            notify.info("Deletion cancelled");
          }
        }}
        sx={{
          fontSize: "0.85rem",
          borderColor: "rgba(255,255,255,0.4)",
          color: "#fff",
          "&:hover": { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.08)" },
        }}
      >
        Delete Avatar
      </Button>

      <FileUploadModel
        open={open}
        setOpen={setOpen}
        fileUploadProps={fileUploadProps}
        handleUploadFile={handleUploadFile}
      />
    </Card>
  );
};

export default ProfileCard;
